<template>
  <div>

    <div class="content-404 section-padding">
      <div class="container text-center ul-li">
        <h2>404</h2>
        <p>ERROR! PAGE NOT FOUND</p>
        <div class="back-home-report margin-top50">
          <ul>
            <li class="fz-button btn-404 margin-right10">
              
              <router-link :to="`/`" class="fz-btn btn">
                Go Back Home
              </router-link>
              <!-- <a href="#">Go Back Home</a> -->
            </li>
            <!-- <li>or</li>
            <li class="fz-button btn-404 margin-left10">
              <button class="fz-btn btn" @click="contactus()">REPORT ERROR</button>
            </li> -->
          </ul>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  created () {
    this.$store.commit('ISLOADING', false)
  },
  methods: {
    contactus () {
      window.location = `${process.env.HOST}#testimonial`
    }
  }
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/PageNotFound.vue